export default "__VITE_ASSET__BSSSYFBU__"